/* eslint-disable import/prefer-default-export */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const checkAlloactionTableHead = [
  {
    headerName: 'Check Log Number',
    field: 'check_log_num',
    editable: false,
    sort: 'asc',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebate_program_cd',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Principal Allocated',
    field: 'credit_voucher_total',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_171,
    wrapText: true,
    autoHeight: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Allocated',
    field: 'interest_voucher_total',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Unallocated Balance Created',
    field: 'allocated',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Unallocated Balance Used',
    field: 'unallocated',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Table Total',
    field: 'check_table_total',
    editable: false,
    wrapText: true,
    autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Difference',
    field: 'diff',
    editable: false,
    wrapText: true,
    autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer,
    comparator: amountComparator,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
